import React, { useState, useEffect } from "react";
import { ProductData } from "../config/SampleData";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/style.css";
import backArrow from "../assets/img/back_arrow.svg";
import { useLocation, useNavigate } from "react-router-dom";
const SummaryPage = ({ onNext, onPrevious }) => {
  const navigate = useNavigate();
  // State to store segregated products
  const [productList, setProductList] = useState([]);

  const location = useLocation();
  const previousPage = location.state?.task;
  const offerNo = location.state?.offerNo;
  const existingCustomerProduct = location.state?.productList;

  // useEffect to segregate products
  useEffect(() => {
    if (existingCustomerProduct?.length > 0) {
      // Get all product_ids from samplrList
      const sampleIds = existingCustomerProduct.map((item) => item.product_id);

      // Filter ProductData to only include products with ids in sampleIds
      const filteredProducts = ProductData.filter((product) =>
        sampleIds.includes(product.id)
      );

      // Map and update properties from samplrList
      const temp = filteredProducts.map((product) => {
        const foundProduct = existingCustomerProduct.find(
          (item) => item.product_id === product.id
        );
        return foundProduct
          ? {
              ...product,
              select: foundProduct.selects === "true",
              section: foundProduct.section,
            }
          : product;
      });

      setProductList(temp);
    } else {
      const allProducts = ProductData?.filter(
        (product) => product?.section !== ""
      );
      setProductList(allProducts);
    }
  }, []);
  const handleNextClick = () => {
    if (onNext) {
      onNext(productList); // Ensure this is called when the "Next" button is clicked
    } else {
      navigate("/rmFormPage", {
        state: {
          task: "summaryPage",
          offerNo: offerNo,
          productList: productList,
        },
      });
    }
  };

  const onBackToCustomerSearch = () => {
    navigate(-1);
  };

  return (
    <div className="content_box" style={{ alignSelf: "center" }}>
      <div className="form-card">
        <div className="summary_box">
          <div className="heading">
            <h3>Summary</h3>
            <h5 style={{ marginBottom: 50 }}>
              {`RM to check with the customers and select products from the
              recommended product section and other section\n\n\n`}
            </h5>
          </div>

          {/* Recommended Products */}
          <div className="recommended_box web">
            <div className="reco_list">
              <h4>Recommended Products</h4>
              <div className="recommended_table">
                <table className="table">
                  <thead>
                    <tr>
                      <th
                        style={{
                          width: "20%",
                          backgroundColor: "#98272A",
                          color: "#fff",
                        }}
                      >
                        Product Name
                      </th>
                      <th
                        style={{
                          width: "45%",
                          backgroundColor: "#98272A",
                          color: "#fff",
                        }}
                      >
                        Product Brief
                      </th>
                      <th
                        style={{
                          width: "25%",
                          backgroundColor: "#98272A",
                          color: "#fff",
                        }}
                      >
                        Video
                      </th>
                      <th
                        style={{
                          width: "10%",
                          backgroundColor: "#98272A",
                          color: "#fff",
                        }}
                      >
                        Select
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {productList?.map((product) => {
                      if (product?.section === "RS") {
                        return (
                          <tr key={product.id}>
                            <td>
                              <div className="product_name">
                                <div className="icon">
                                  <img src={product?.icon} alt={""} />
                                </div>
                                <div className="text">
                                  <p>
                                    <b>{product?.name}</b>
                                  </p>
                                </div>
                              </div>
                            </td>
                            <td>{product.brief}</td>
                            <td
                              style={{
                                maxWidth: "160px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              <a
                                href={product?.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                title={product?.link}
                              >
                                {product?.urlLabel
                                  ? product?.urlLabel
                                  : product?.link}
                              </a>
                            </td>
                            <td>
                              <div className="custom-checkbox">
                                <input
                                  id={`product-${product?.id}`}
                                  name={`product-${product?.id}`}
                                  type="checkbox"
                                  value={product?.select}
                                  checked={product?.select}
                                  onChange={() => {
                                    const temp = productList?.find(
                                      (item) => item.id === product.id
                                    );
                                    temp.select = !temp.select;
                                    setProductList(
                                      productList?.map((item) =>
                                        item.id === product.id ? temp : item
                                      )
                                    );
                                  }}
                                />
                              </div>
                            </td>
                          </tr>
                        );
                      }
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Other Products */}
          <div className="recommended_box web">
            <div className="reco_list">
              <h4>Other Products</h4>
              <div className="recommended_table">
                <table className="table">
                  <thead>
                    <tr>
                      <th
                        style={{
                          width: "20%",
                          backgroundColor: "#98272A",
                          color: "#fff",
                        }}
                      >
                        Product Name
                      </th>
                      <th
                        style={{
                          width: "45%",
                          backgroundColor: "#98272A",
                          color: "#fff",
                        }}
                      >
                        Product Brief
                      </th>
                      <th
                        style={{
                          width: "25%",
                          backgroundColor: "#98272A",
                          color: "#fff",
                        }}
                      >
                        Video
                      </th>
                      <th
                        style={{
                          width: "10%",
                          backgroundColor: "#98272A",
                          color: "#fff",
                        }}
                      >
                        Select
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {productList?.map((product) => {
                      if (product?.section === "OS") {
                        return (
                          <tr key={product.id}>
                            <td>
                              <div className="product_name">
                                <div className="icon">
                                  <img src={product?.icon} alt={""} />
                                </div>
                                <div className="text">
                                  <p>
                                    <b>{product?.name}</b>
                                  </p>
                                </div>
                              </div>
                            </td>
                            <td>{product.brief}</td>
                            <td
                              style={{
                                maxWidth: "160px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              <a
                                href={product?.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                title={product?.link}
                              >
                                {product?.urlLabel
                                  ? product?.urlLabel
                                  : product?.link}
                              </a>
                            </td>
                            <td>
                              <div className="custom-checkbox">
                                <input
                                  id={`product-${product?.id}`}
                                  name={`product-${product?.id}`}
                                  type="checkbox"
                                  value={product?.select}
                                  checked={product?.select}
                                  onChange={() => {
                                    const temp = productList?.find(
                                      (item) => item.id === product.id
                                    );
                                    temp.select = !temp.select;
                                    setProductList(
                                      productList?.map((item) =>
                                        item.id === product.id ? temp : item
                                      )
                                    );
                                  }}
                                />
                              </div>
                            </td>
                          </tr>
                        );
                      }
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Process Text */}
          <div className="process_text">
            <p>
              You can proceed by clicking on Submit button and a consolidated
              offer letter will be emailed by your Relationship Manager on your
              official email ID
            </p>
            {/* <div className="submit_btn">
                            <button className="back_summary" onClick={() => { onPrevious() }}>Back</button>
                            <button className="submit" onClick={handleNextClick}>Submit</button>
                        </div> */}
            <div className="next_btn basic_ques text-center">
              <button
                type="button"
                className="custom mt-0 mr-3"
                style={{ backgroundColor: "white", color: "black" }}
                onClick={() => {
                  previousPage === "customerSearch1"
                    ? onBackToCustomerSearch()
                    : onPrevious();
                }}
              >
                <img className="back" src={backArrow} alt="Back" /> Back
              </button>
              <button
                type="submit"
                className="custom mt-0"
                style={{
                  backgroundColor: "#98272A",
                  color: "white",
                  marginLeft: 20,
                }}
                onClick={handleNextClick}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SummaryPage;
